import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CodeReaderPrivacyPolicyZhCn() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 隐私政策

"二维码扫描器: Fast"（以下简称"本应用"）尊重用户的隐私，致力于保护个人信息。本应用不收集用户的个人信息，并采取措施保护用户数据。本隐私政策（以下简称"本政策"）规定了本应用中信息的处理方式。

## 第1条（个人信息收集与管理方针）

本应用不收集用户的任何个人信息（如姓名、地址、电话号码等）。应用内的所有功能都基于不收集个人信息的前提设计。此外，为保护用户隐私，我们不收集或存储任何可识别个人身份的信息。

## 第2条（用户数据存储）

在本应用中，用户扫描的所有结果仅存储在用户设备中，不会保存到外部服务器。因此，本应用及其开发者无法访问用户扫描的数据。我们保证这些数据不会提供给第三方，并将安全地存储在用户设备中。

## 第3条（广告投放）

本应用通过Google AdMob投放广告。在广告投放过程中，Google提供的系统可能会自动收集用于广告优化的数据，但这些数据按照Google的隐私政策进行管理。本应用不保留任何与广告投放相关的个人信息。详情请参阅Google的隐私政策。

## 第4条（用户权利与数据管理）

本应用确保用户可以完全控制自己的数据。用户可以随时删除应用内的数据，本应用在未经用户操作的情况下不会向外部传输数据。此外，根据使用条款，由于使用本应用时不使用个人信息，因此不适用于信息公开、更正、删除或停止使用的请求。

## 第5条（隐私政策的变更）

本应用可能会定期审查本政策内容，并根据法律修订或应用功能变更等情况对本政策进行修改，以提高用户隐私保护。发生变更时，我们将通过在本应用内发布最新的隐私政策通知用户，该政策将在发布后立即生效。请用户定期查看本政策。

## 第6条（联系方式）

如对本政策有任何疑问或咨询，请通过以下方式联系我们：

电子邮箱：linappworks@gmail.com
  `;

  return (
    <Container>
      <Content>
        <Title>Privacy Policy</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default CodeReaderPrivacyPolicyZhCn; 
